import styled from 'styled-components';

const StyledLabel = styled.span`
  font-size: 14px;
`;

export default StyledLabel;
